// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   SettingsPage.responsive.css
   Responsive Stylesheet for Workspace Settings & Quotas
   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED
   ========================================================================== */

/* ==========================================================================
   IPAD & TABLETS (max-width: 1024px)
   ========================================================================== */
@media (max-width: 1024px) {
  .mgsettings-page {
    width: 100%;
    max-width: 100vw;
    padding: 14px 18px 40px !important;
    overflow-x: hidden;
  }

  .mgsettings-hero {
    grid-template-columns: 1fr !important;
    gap: 22px !important;
    padding: 24px !important;
  }

  .mgsettings-hero h1 {
    font-size: clamp(28px, 4.2vw, 36px) !important;
    line-height: 1.1 !important;
  }

  .mgsettings-hero-panel {
    max-width: 100% !important;
    padding: 20px !important;
  }

  .mgsettings-stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 12px !important;
    margin: 18px 0 !important;
  }

  .mgsettings-grid {
    grid-template-columns: 1fr !important;
    gap: 16px !important;
  }
}

/* ==========================================================================
   MOBILE PHONES (max-width: 768px)
   ========================================================================== */
@media (max-width: 768px) {
  .mgsettings-page {
    padding: 10px 10px 30px !important;
  }

  .mgsettings-hero {
    padding: 16px 14px !important;
    gap: 14px !important;
    border-radius: 16px !important;
  }

  .mgsettings-hero h1 {
    font-size: 24px !important;
    line-height: 1.15 !important;
  }

  .mgsettings-hero p {
    font-size: 13px !important;
    line-height: 1.5 !important;
    margin: 10px 0 14px !important;
  }

  .mgsettings-actions {
    display: flex !important;
    gap: 8px !important;
    flex-wrap: wrap !important;
    width: 100% !important;
  }

  .mgsettings-actions .mgsettings-btn {
    flex: 1 1 auto !important;
    min-height: 40px !important;
    font-size: 12.5px !important;
  }

  .mgsettings-hero-panel {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  /* Stats grid */
  .mgsettings-stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 6px !important;
    margin: 14px 0 !important;
  }

  .mgsettings-stat-card {
    padding: 10px 8px !important;
    border-radius: 12px !important;
  }

  .mgsettings-stat-card strong {
    font-size: 18px !important;
  }

  .mgsettings-stat-card span {
    font-size: 10px !important;
  }

  .mgsettings-stat-card small {
    display: none !important;
  }

  .mgsettings-card {
    padding: 16px 14px !important;
    border-radius: 14px !important;
    margin-bottom: 14px !important;
  }

  .mgsettings-card h2 {
    font-size: 17px !important;
  }

  .mgsettings-card .form-group,
  .mgsettings-card .form-field {
    width: 100% !important;
  }

  .mgsettings-card input,
  .mgsettings-card select {
    width: 100% !important;
    min-height: 40px !important;
    font-size: 13.5px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SettingsPage.responsive.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;+EAE+E;AAC/E;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,8CAA8C;IAC9C,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,2DAA2D;IAC3D,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;EACtB;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA,eAAe;EACf;IACE,2DAA2D;IAC3D,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF","sourcesContent":["/* ==========================================================================\n   SettingsPage.responsive.css\n   Responsive Stylesheet for Workspace Settings & Quotas\n   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED\n   ========================================================================== */\n\n/* ==========================================================================\n   IPAD & TABLETS (max-width: 1024px)\n   ========================================================================== */\n@media (max-width: 1024px) {\n  .mgsettings-page {\n    width: 100%;\n    max-width: 100vw;\n    padding: 14px 18px 40px !important;\n    overflow-x: hidden;\n  }\n\n  .mgsettings-hero {\n    grid-template-columns: 1fr !important;\n    gap: 22px !important;\n    padding: 24px !important;\n  }\n\n  .mgsettings-hero h1 {\n    font-size: clamp(28px, 4.2vw, 36px) !important;\n    line-height: 1.1 !important;\n  }\n\n  .mgsettings-hero-panel {\n    max-width: 100% !important;\n    padding: 20px !important;\n  }\n\n  .mgsettings-stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 12px !important;\n    margin: 18px 0 !important;\n  }\n\n  .mgsettings-grid {\n    grid-template-columns: 1fr !important;\n    gap: 16px !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONES (max-width: 768px)\n   ========================================================================== */\n@media (max-width: 768px) {\n  .mgsettings-page {\n    padding: 10px 10px 30px !important;\n  }\n\n  .mgsettings-hero {\n    padding: 16px 14px !important;\n    gap: 14px !important;\n    border-radius: 16px !important;\n  }\n\n  .mgsettings-hero h1 {\n    font-size: 24px !important;\n    line-height: 1.15 !important;\n  }\n\n  .mgsettings-hero p {\n    font-size: 13px !important;\n    line-height: 1.5 !important;\n    margin: 10px 0 14px !important;\n  }\n\n  .mgsettings-actions {\n    display: flex !important;\n    gap: 8px !important;\n    flex-wrap: wrap !important;\n    width: 100% !important;\n  }\n\n  .mgsettings-actions .mgsettings-btn {\n    flex: 1 1 auto !important;\n    min-height: 40px !important;\n    font-size: 12.5px !important;\n  }\n\n  .mgsettings-hero-panel {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  /* Stats grid */\n  .mgsettings-stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 6px !important;\n    margin: 14px 0 !important;\n  }\n\n  .mgsettings-stat-card {\n    padding: 10px 8px !important;\n    border-radius: 12px !important;\n  }\n\n  .mgsettings-stat-card strong {\n    font-size: 18px !important;\n  }\n\n  .mgsettings-stat-card span {\n    font-size: 10px !important;\n  }\n\n  .mgsettings-stat-card small {\n    display: none !important;\n  }\n\n  .mgsettings-card {\n    padding: 16px 14px !important;\n    border-radius: 14px !important;\n    margin-bottom: 14px !important;\n  }\n\n  .mgsettings-card h2 {\n    font-size: 17px !important;\n  }\n\n  .mgsettings-card .form-group,\n  .mgsettings-card .form-field {\n    width: 100% !important;\n  }\n\n  .mgsettings-card input,\n  .mgsettings-card select {\n    width: 100% !important;\n    min-height: 40px !important;\n    font-size: 13.5px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
